import { Container } from '@mui/material';
import { NavLink } from "react-router-dom";

import { useUserContext } from "../../../contexts/userContext";

import PermissionGate from "../../permissionGate";
import Navigation from "../../header";
import { Icons } from '../../icons';

import WasteCharacterizationAddForm from '../../forms/wasteCharacterizationAddForm';

const WasteCharacterizationAdd = () => {
	const userContext = useUserContext();

	return (
		<div className="hwi-waste-characterization-add">
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={true /* userContext.permissions?.can */}>
					<section className="management-page-header">
						<div className="title">
							<NavLink to="/wastecharacterization" className="back-link">
								<Icons.GoBack fill="#9399ad" height="24px"></Icons.GoBack>
							</NavLink>
							Add Waste Characterizaton
						</div>
					</section>
					<section className="management-page-form">
						<WasteCharacterizationAddForm></WasteCharacterizationAddForm>
					</section>
				</PermissionGate>
			</Container>
		</div>
	);
};

export default WasteCharacterizationAdd;